<template>
  <div class="mt-3">
    <div v-if="isFetching" class="text-center">
      <FontAwesomeIcon icon="fa-solid fa-spinner" spin />
      <span>loading...</span>
    </div>
    <div v-if="!isFetching" class="row custom-card-group">
      <div v-for="(item, idx) of panelSet1" :key="idx"
        class="col card custom-card custom-card-provider custom-card-provider-background"
        :style="{ 'background-color': item.color + ' !important' }">
        <div class="custom-info">
          <a v-popover tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus hover" data-bs-html="true"
            data-bs-sanitize="false" title="Information" :data-bs-content="processNotes(item)" class="btn btn-link"
            role="button">
            <i class="fas fa-info-circle"></i>
          </a>
        </div>
        <div class="card-body custom-card-body">
          <p class="card-text custom-text">{{ item.name }}</p>

          <h5 class="card-title custom-card-provider-title">{{ item.number }}</h5>
        </div>
      </div>
    </div>
    <div v-if="!isFetching" class="row custom-card-group mt-3">
      <div v-for="(item, idx) of panelSet2" :key="idx"
        class="col card custom-card custom-card-provider custom-card-provider-background"
        :style="{ 'background-color': item.color + ' !important' }">
        <div class="custom-info">
          <a v-popover tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus hover" data-bs-html="true"
            data-bs-sanitize="false" title="Information" :data-bs-content="processNotes(item)" class="btn btn-link"
            role="button">
            <i class="fas fa-info-circle"></i>
          </a>
        </div>
        <div class="card-body custom-card-body">
          <p class="card-text custom-text">{{ item.name }}</p>
          <h5 class="card-title custom-card-provider-title">{{ item.number }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { dashboardStore } from '@/stores/dashboard'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'ProviderDashboard',
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['preferences']),
    ...mapState(dashboardStore, ['isFetching', 'providerDashboard']),
    isProvider() {
      let _is = false
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    panelSet1() {
      let _set = []
      if (this.providerDashboard) {
        _set = this.providerDashboard.filter((item) => item.panel === 1)
      }
      console.log('Panel Set 1', _set)
      return _set
    },
    panelSet2() {
      let _set = []
      if (this.providerDashboard) {
        _set = this.providerDashboard.filter((item) => item.panel === 2)
      }
      console.log('Panel Set 2', _set)
      return _set
    }
  },
  methods: {
    processNotes(item) {
      let _notes = ''
      if (item) {
        if (item.notes) {
          _notes = item.notes
        }
        console.log('Notes', _notes)
      }
      return _notes
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-card-provider-background {
  background-color: #b3d7ff !important;
}

.custom-card-provider {
  min-height: 150px;
  font-size: 1.4rem;
}

.custom-text {
  font-weight: 600;
  padding-bottom: 10px;
  border-bottom: 1px solid #dbdbdb;
}

.custom-card-provider-title {
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0;
  font-size: 2.1rem;
}

.custom-info {
  position: absolute;
  top: 0px;
  z-index: 10;
}
</style>
